exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../../colours.icss"), undefined);

// module
exports.push([module.id, ".Posts__postImage___3yyJO {\n\tborder-radius: 50%;\n\tbox-shadow: 0px 1px 5px 1px rgba(33,33,33,0.1);\n}\n\n.Posts__noPosts___1UENB {\n\tpadding: " + require("-!../../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../../colours.icss").locals["pagePadding"] + ";\n}\n", ""]);

// exports
exports.locals = {
	"pagePadding": "" + require("-!../../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../../colours.icss").locals["pagePadding"] + "",
	"postImage": "Posts__postImage___3yyJO",
	"noPosts": "Posts__noPosts___1UENB"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/User/Posts.icss
// module id = 1591
// module chunks = 0